import React, { ComponentType } from 'react'
import { FastField, FastFieldProps, FastFieldAttributes } from 'formik'

interface IFastFieldWrapperProps
  extends FastFieldProps,
    FastFieldAttributes<any> {
  component: ComponentType<any>
}

const FastFieldWrapper =
  (Component: ComponentType<any>) =>
  (props: Omit<IFastFieldWrapperProps, 'component'>) => (
    <FastField component={Component} {...props} />
  )

export default FastFieldWrapper
